<template>
  <div>
    <div v-if="loading">
      <div class="card-panel" v-loading="loading" style="height:110px">

      </div>
    </div>

    <template v-else-if="ledger">
      <cardBalanceView 
        v-if="ledger.vender_type !== 'ifx'" 
        :ledger="ledger"
        v-on:onClick="viewAccount()"
        >
      </cardBalanceView>

      <cardBalanceViewIFX 
        v-if="ledger.vender_type === 'ifx'" 
        :ledger="ledger"
        v-on:onClick="viewAccount()"
        >
      </cardBalanceViewIFX>
      </template>
    </div>

</template>

<script>
import cardBalanceView from "./card-balance-view.vue";
import cardBalanceViewIFX from "./card-balance-view-ifx.vue";
import {
  getProjectBalanceByLedger,
  getCustomerBalanceByLedger,
} from "@/api/bank-account";
export default {
  props:{
    projectUID: String,
    customerUID: String,
    ledgerID: String,
    apiMode:String
  },
  components:{
    cardBalanceView,
    cardBalanceViewIFX
  },
  data(){
    return{
        loading: false,
        ledger : null
    }
  },
  methods:{
    getLedgerBalance(){
      this.loading = true
      if(this.apiMode === 'project'){
        getProjectBalanceByLedger(this.projectUID, this.ledgerID).then(({result, data})=>{
          if(result){
              this.loading = false
              this.ledger = data
          }
        })
      }
      if(this.apiMode === 'customer'){
        getCustomerBalanceByLedger(this.customerUID, this.ledgerID).then(({result, data})=>{
          if(result){
              this.loading = false
              this.ledger = data
          }
        })
      }
    },
    viewAccount(){
      this.$router.push(`/bank-account/view/${this.apiMode}/${this.ledger.bankholderID}`)
    },

  },
  created(){
    this.getLedgerBalance()
  }
};
</script>
